module.exports = __webpack_public_path__ + "img/defaultAvatar.a60613b4.jpg";